import React from 'react'

/**
 * ExampleChild
 *
 */
class ExampleChild extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      status: 'constructor called'
    }

    this.myEl = null
  }

  render() {
    const styleButton = {
      padding: '12px 14px',
      margin: '10px 0',
      borderRadius: '8px',
      color: '#fff',
      background: '#001eff'
    }

    return (
      <div id='user-child' style={{background: '#f2f2f2', padding: '20px', height: '250px'}}>

        I am trapped in a container and want to break out<br />

        <button onClick={this.props.onClickButton} style={styleButton}>Toggle breakout</button>

      </div>
    )
  }
}

export default ExampleChild
